// src/components/FieldScoreboardTabs.js
import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import TabPanelScoreboard from './TabPanelScoreboard';
import TableroFieldEvents from './TableroFieldEvents';
import GestionTablerosField from './GestionTablerosField';

const FieldScoreboardTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  // Estados para manejar las configuraciones y ventanas abiertas
  const [configurations, setConfigurations] = useState(() => {
    const savedConfigs = localStorage.getItem('fieldConfigurations');
    return savedConfigs ? JSON.parse(savedConfigs) : [];
  });
  
  const [openWindows, setOpenWindows] = useState({});
  
  // Función para abrir un tablero de campo
  const openTablero = (configId) => {
    const configToLoad = configurations.find((config) => config.id === configId);
    if (configToLoad) {
      localStorage.setItem(`config-${configId}`, JSON.stringify(configToLoad));
      
      // Determinar la página a abrir según el tipo de evento
      const path = `/field-scoreboard?id=${configId}`;
      
      // Abrir la ventana con dimensiones adecuadas
      const width = configToLoad.settings?.tableWidth || 800;
      const height = configToLoad.settings?.tableHeight || 600;
      
      const newWindow = window.open(
        path, 
        `tablero-${configId}`, 
        `width=${width},height=${height},menubar=no,toolbar=no,location=no,status=no`
      );
      
      if (newWindow) {
        setOpenWindows((prevWindows) => ({ ...prevWindows, [configId]: newWindow }));
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        centered
        variant="fullWidth"
        indicatorColor="secondary"
        textColor="inherit"
      >
        <Tab label="Ajustes" />
        <Tab label="Tableros" />
      </Tabs>
      <TabPanelScoreboard value={activeTab} index={0}>
        {/* Componente de ajustes para eventos de campo */}
        <TableroFieldEvents
          configurations={configurations}
          setConfigurations={setConfigurations}
          openTablero={openTablero}
          openWindows={openWindows}
          setOpenWindows={setOpenWindows}
        />
      </TabPanelScoreboard>
      <TabPanelScoreboard value={activeTab} index={1}>
        {/* Componente para gestionar tableros de campo */}
        <GestionTablerosField
          configurations={configurations}
          setConfigurations={setConfigurations}
          openTablero={openTablero}
          openWindows={openWindows}
        />
      </TabPanelScoreboard>
    </Box>
  );
};

export default FieldScoreboardTabs;